import { apiSlice } from '@/api';
import { Breakdown } from './types';

export const adStatsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAdStatsBreakdowns: builder.query<
      Breakdown[],
      { id: string; type: 'hour' | 'day' }
    >({
      query: ({ id, type }) => ({
        url: `/v1/stats/breakdowns?id=${id}&type=${type}`,
        method: 'GET',
      }),
      transformResponse: (response: { result: Breakdown[] }) => response.result,
    }),
  }),
});

export const { useGetAdStatsBreakdownsQuery } = adStatsApi;
